Handlebars.registerHelper('customconsole', function(params) {
	console.log("HANDLEBARS params: ", params);
});

Handlebars.registerHelper('ifCond', function(v1, v2, options) {
  if(v1 === v2) {
	return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper('ifCondCaseInsensitive', function(v1, v2, options) {
	var v1Str = new String(v1),
		v2Str = new String(v2);
	if(v1Str.toLowerCase() === v2Str.toLowerCase()) {
	  return options.fn(this);
	}
	return options.inverse(this);
});

Handlebars.registerHelper('ifNotCondCaseInsensitive', function(v1, v2, options) {
	var v1Str = new String(v1),
		v2Str = new String(v2);
	if(v1Str.toLowerCase() !== v2Str.toLowerCase()) {
	  return options.fn(this);
	}
	return options.inverse(this);
});

Handlebars.registerHelper('ifGreater', function(v1, v2, options) {
	  if(v1 > v2) {
		return options.fn(this);
	  }
	  return options.inverse(this);
	});

Handlebars.registerHelper('SubstringHelper', function(variable, i1, i2){
	return variable.substring(i1,i2);
});

// {{condition a == 'name'}}
Handlebars.registerHelper('condition', function (v1, operator, v2, options) {
	switch (operator) {
	    case '==':
	        return (v1 == v2) ? options.fn(this) : options.inverse(this);
	    case '===':
	        return (v1 === v2) ? options.fn(this) : options.inverse(this);
        case '!==':
            return (v1 !== v2) ? options.fn(this) : options.inverse(this);
        case '!=':
            return (v1 != v2) ? options.fn(this) : options.inverse(this);
	    case '<':
	        return (v1 < v2) ? options.fn(this) : options.inverse(this);
	    case '<=':
	        return (v1 <= v2) ? options.fn(this) : options.inverse(this);
	    case '>':
	        return (v1 > v2) ? options.fn(this) : options.inverse(this);
	    case '>=':
	        return (v1 >= v2) ? options.fn(this) : options.inverse(this);
	    case '&&':
	        return (v1 && v2) ? options.fn(this) : options.inverse(this);
	    case '||':
	        return (v1 || v2) ? options.fn(this) : options.inverse(this);
	    default:
	        return  (options == undefined) ? operator : options.inverse(this);
	}

});

Handlebars.registerHelper('ifNotCond', function(v1, v2, options) {
	  if(v1 !== v2) {
		return options.fn(this);
	  }
	  return options.inverse(this);
	});

Handlebars.registerHelper('valueInArrayCond', function(value, elements, options) {
	elements = JSON.parse(elements);
	for(var i = 0; i < elements.length; i++) {
		if (value == elements[i]) {
			return options.fn(this);
		}
	}
	return options.inverse(this);
});

Handlebars.registerHelper('ifGreater', function(v1, v2, options) {
	  if(v1 > v2) {
		return options.fn(this);
	  }
	  return options.inverse(this);
	});

Handlebars.registerHelper("partialHelper", function (name, options) {
	var partial = Handlebars.partials[name];
	if (!partial) return "";
	return new Handlebars.SafeString(partial(this));
});

Handlebars.registerHelper("tilecssClassName", function(tileType, col, index, name, url) {

	var cssName = (tileType == 'brandingTile') ? 'branding-tile ' : 'plp-tile ';
	var modIndex = index+1;

	if(name!==undefined && url === undefined)
		modIndex = index+2;

	if(col === undefined)
		return cssName;

	col = col.toString();

	if(col == "2"){
		cssName += " colSpan2";
	}

	return cssName;
});

Handlebars.registerHelper("EnableDisable", function(count) {
	if(count === undefined || count == "0" || Number(count) === 0 || count==="")
		return "disabled";

	return;
});

Handlebars.registerHelper("EnableDisableContainer", function(count) {
	if(count === undefined || count == "0" || Number(count) === 0 || count==="")
		return "rb-input-disabled";

	return;
});


Handlebars.registerHelper('position', function(positionCounter, step) {
        return positionCounter + step;
});

Handlebars.registerHelper('LowerCase', function(str) {
	if (str != undefined)
        return str.toLowerCase();
});

Handlebars.registerHelper('ReplaceSpace', function (str) {
	if (str !== undefined) {
		return str.replace(' ', '');
	}
});

Handlebars.registerHelper('PriceSlider', function(priceArr) {
      var $sliderDiv = $('<div class="rb-input rb-input-checkbox">'+'<label for="rb-input-checkbox-">'+'<input id="rb-input-checkbox-" name="" type="checkbox" value="" style="" onchange="">'+'<span><span class="rb-filter-price-label "><span class="rb-filter-price-currency-output"><span class="rb-filter-price-output">'+"'+Around $100 - below+'"+'</span></span></span></span>'+'<p class="rb-input-error"></p>' );
      var $sliderElem =  $('<input class="rb-filter-price-input" type="range" id="price_range" name="price_range" min="1" max="'+priceArr.length+'" step="1" value="1"/>');

	  var $sliderIpCntr = $('<div class="rb-filter-price-input-values">');
	  var $sliderInput = $('<input type="hidden" name="facet" value="'+priceArr[0].entryValue+'" />');
		 $.each(priceArr,function(index,priceObj){
			var stepVal = 'data-step'+(index+1);
			var stepLabel = 'data-label'+(index+1);

			$sliderInput.attr(stepVal, priceObj.entryValue);
			$sliderInput.attr(stepLabel, priceObj.label);
		 });

		$sliderIpCntr.append($sliderInput);
      return new Handlebars.SafeString($sliderDiv.prop('outerHTML') + $sliderElem.prop('outerHTML') + $sliderIpCntr.append($sliderInput).prop('outerHTML'));
});

Handlebars.registerHelper('Encode', function(str) {
	return encodeURI(str);
});

Handlebars.registerHelper('include', function(options) {
    var context = {},
        mergeContext = function(obj) {
            for(var k in obj)context[k]=obj[k];
        };
    mergeContext(this);
    mergeContext(options.hash);
    return options.fn(context);
});

Handlebars.registerHelper('StyleHelper', function(style) {
	var styleArr = style.split(" ");
	var $styleCount = $("<span>");
	var $colorCount = "";
	var $colorText = "";
	$styleCount.html(styleArr[0]);

	var $styleText = $("<span>");
	$styleText.html(styleArr[1]);

	if(styleArr[2] !== undefined){
		$colorCount = $("<span>");
		$colorCount.html(styleArr[2]);
	}
	if(styleArr[3] !== undefined){
		$colorText = $("<span>");
		$colorText.html(styleArr[3]);
	}

	var retrunHTML = $styleCount.add($styleText);

	return new Handlebars.SafeString($styleCount.prop("outerHTML") +" "+ $styleText.prop("outerHTML"));
});

Handlebars.registerHelper('removeFacetHelper', function(value, mainLabel) {
	var lensOrGenderFlag = mainLabel == "LENS_TREATMENT_FACET" || mainLabel == "GENDER";
	if(lensOrGenderFlag || value.indexOf(",") != -1)
		value =  "'" + value + "',"+ true;
	else
		value =  "'" + value + "'";

	return value;
});

Handlebars.registerHelper('decodeHTML', function(value) {
	var html = value.split('&lt;').join('<').split("&gt;").join('>');
	return new Handlebars.SafeString(html);
});

Handlebars.registerHelper("isNewRow", function(index, options){
  if((parseInt(index)+1) % 3 == 1) {
  	return options.fn(this);
  }
  else return options.inverse(this);
});

Handlebars.registerHelper("isRowEnd",function(index, options){
  if((parseInt(index)+1) % 3 === 0) {
  	return options.fn(this);
  }
  else return options.inverse(this);
});


Handlebars.registerHelper("isCarouselActive", function(selected) {
	var activeCarousel = "";
	if(selected == "true" || selected === true){
		activeCarousel = "wcs-selected";
	}

	return activeCarousel;

});


Handlebars.registerHelper("getProduct",function(products,colorData){
     var product="";
     var skuVal = "";
     if(colorData.hasOwnProperty("polar_skuId") && colorData.polar_skuId !== "" && colorData.polar_skuId.split(",").length <2) skuVal = colorData.polar_skuId;
     else if(colorData.hasOwnProperty("value") && colorData.value !== "") skuVal = colorData.value;
      if(products.hasOwnProperty(skuVal)){
      	product = products[skuVal];
      }
     return product;
});

Handlebars.registerHelper("getImageUrl",function(imgurl){
     var url="";
      if(imgurl){
      	url = imgurl+"?impolicy=RB_297x150";
      }
     return url;
});

Handlebars.registerHelper('listLensColors', function(colors, options) {
  var htmlTxt = "";
  var colorArray = [];
  for(var i=0; i< colors.length; i++) {
    var lensColor = colors[i].details.lensValueLabel;
    var frameColor = colors[i].details.frameValueLabel;
    if($.inArray(lensColor,colorArray) == -1){
	    htmlTxt += "<li><div class='select'></div><div class='circle' style='background-image: url(//images.ray-ban.com/is/image/RayBan/lens-swatch_"+pdpdata.products[colors[i].details.value].clen+".png?impolicy=RB_png-full);'></div>" + lensColor;
	    htmlTxt += "<input type='hidden' class = 'lensColorVal' value='"+ lensColor +"'>";
	    htmlTxt += "<input type='hidden' class = 'frameColorVal' value='"+ frameColor +"'>";
	    if(colors[i].details.hasOwnProperty('polar_skuId')){
	    	htmlTxt += "<input type='hidden' class = 'lensColor_polar' value='"+ colors[i].details.polar_skuId +"'>";
    	}
	    htmlTxt += "<input type='checkbox' class='lensColor-checkbox' name ='lensColor_check'></li>";
	    colorArray.push(lensColor);
    }
  }
  return htmlTxt;
});

Handlebars.registerHelper('listFrameColors', function(colors, options) {
  var htmlTxt = "";
  var colorArray = [];
  for(var i=0; i< colors.length; i++) {
    var frameColor = colors[i].details.frameValueLabel;
    if($.inArray(frameColor,colorArray) == -1){
	    htmlTxt += "<li><div></div>" + frameColor;
	    htmlTxt += "<input type='hidden' class = 'frameColorVal' value='"+ frameColor +"'>";
	    if(colors[i].details.hasOwnProperty('polar_skuId')){
	    	htmlTxt += "<input type='hidden' class = 'frameColor_polar' value='"+ colors[i].details.polar_skuId +"'>";
	    }
	    htmlTxt += "<input type='checkbox' class='frameColor-checkbox' name ='frameColor_check'></li>";
	    colorArray.push(frameColor);
    }
  }
  return htmlTxt;
});

Handlebars.registerHelper("toHTML",function(html){
	return new Handlebars.SafeString(html);
});

Handlebars.registerHelper("toInt",function(price){
	return parseInt(price);
});

Handlebars.registerHelper("toFloat",function(price){
	return parseFloat(price).toFixed(2);
});

Handlebars.registerHelper("toMicroUnits",function(price){
	return parseFloat(price).toFixed(2) * 100;
});

Handlebars.registerHelper('showLensType', function(productData, options) {
	  var lensTypes = productData;
	  if(null !==lensTypes && undefined !==lensTypes && (lensTypes.length > 1 || (lensTypes.length == 1 && lensTypes[0].hasOwnProperty("imgUrl") && lensTypes[0].imgUrl !==""))) {
		return options.fn(this);
	  }
	  return options.inverse(this);
});

Handlebars.registerHelper('checkLength', function(productData, options) {
	  var size = productData;
	  if(null !== size && undefined !==size && size.length > 1) {
		return options.fn(this);
	  }
	  return options.inverse(this);
});
Handlebars.registerHelper('getUnavailability', function(prodSku, options) {
	  var availableData = window.availabilityData;
	  var availabilityHTML = "";
	  if(availableData[prodSku].buyableqty === 0){
         if(availableData[prodSku].currentlyUnavailableLabel) availabilityHTML = "<div class='unavailable'>"+availableData[prodSku].currentlyUnavailableLabel+"</div>";
         else if(availableData[prodSku].notSellableOnlineMsg) availabilityHTML = "<div class='unavailable'>"+availableData[prodSku].notSellableOnlineMsg+"</div>";
	  }
	  return availabilityHTML;
});
Handlebars.registerHelper('isUnavailable', function(prodSku, options) {
	  var availableData = window.availabilityData;
	  if(availableData[prodSku].buyableqty === 0){
	  	return options.fn(this);
	  }
	  else return options.inverse(this);
});
Handlebars.registerHelper('isAvailable', function(rxsku, prodSku, options) {
	  var availableData = window.availabilityData;
	  var product = window.pdpdata.products[rxsku];
	  if(availableData[prodSku].buyableqty !== 0 || (availableData[prodSku].buyableqty === 0 && (!availableData[prodSku].currentlyUnavailableLabel && !availableData[prodSku].notSellableOnlineMsg))){
		  if(product.buyable === 'true' && product.unFormattedPrice && availableData[rxsku].addToBagFlag === 'Y' ){
		  	return options.fn(this);
		  }
		  else return options.inverse(this);
	  }
	  else return options.inverse(this);

});
Handlebars.registerHelper('isNotRoxLens', function(options) {
	  if($("#isRoxEnabled").length > 0 && $("#isRoxEnabled").val() == "true"){
	  	return options.inverse(this);
	  }
	  else return options.fn(this);
});
Handlebars.registerHelper('isRoxPDP', function(options) {
	  if($("#isRoxEnabled").length > 0 && $("#isRoxEnabled").val() == "true"){
	  	return options.fn(this);
	  }
	  else return options.inverse(this);
});

Handlebars.registerHelper('isSelectedFrame', function(frameCatId, options) {
	  var selectedFrameId = $("#pdpFrameCatId").val();
	  if(frameCatId == selectedFrameId) {
		return options.fn(this);
	  }
	  return options.inverse(this);
});
Handlebars.registerHelper('getPrescriptionLabel', function(){
    var prescriptionlabel = $(".rox-header-prescription span").text();
    return prescriptionlabel;
});
Handlebars.registerHelper('getPrescriptioninfoLabel', function(){
	var prescriptionHTML = $("#DESK_ROX_PrescriptionInfo").html();
	if(prescriptionHTML !== ""){
		return new Handlebars.SafeString(prescriptionHTML);
	}
	else return prescriptionHTML;

});
Handlebars.registerHelper('getPrescriptionTooltipHtml', function(){
	var prescriptionTooltipHTML = $("#DESK_ROX_PrescriptionTooltip").html();
	if(prescriptionTooltipHTML !== ""){
        return new Handlebars.SafeString(prescriptionTooltipHTML);
	}
	else return prescriptionTooltipHTML;
});
Handlebars.registerHelper('isAvantPremierDateNotExpired', function(avantDate,webExclusive,avantPremiereMsg,webExclusiveMsg,options){
	var msg="";
	var isAvantMsgEligable=false;
	Date.prototype.withoutTime = function () {
	    var d = new Date(this);
	    d.setHours(0, 0, 0, 0);
	    return d;
	};
	if(avantDate!==undefined) {
		var year=avantDate.substr(0, 4);
		var month=avantDate.substr(4, 2)-1;
	    var date=avantDate.substr(6, 2);
		var inputDate = new Date(year,month,date);

		if(new Date().withoutTime()<=inputDate.withoutTime()) {
			isAvantMsgEligable=true;
		}
	}

	if(isAvantMsgEligable=== true){
		msg=avantPremiereMsg;
	}else if (webExclusive !==undefined && webExclusive==='true'){
		msg=webExclusiveMsg;
	}
	return new Handlebars.SafeString(msg);
});

Handlebars.registerHelper('RBDebug', function(data){
	console.debug('HBS - RBDebug');
	console.debug(data);
});

Handlebars.registerHelper("formatRCOverlayTooltip", function(overlayTooltipHTML, catId, options){
	if(pdpdata.lensGuide.hasOwnProperty(catId)){
		return new Handlebars.SafeString(Rayban.utilities.interpolateString(overlayTooltipHTML,pdpdata.lensGuide[catId]));
	}
});

Handlebars.registerHelper("isBenefitApplied", function(options){
	if(Rayban.utilities.readCookie("EyeMedLogin") === "true"){
	  	return options.fn(this);
	  }
	else {
		return options.inverse(this);
	}
});

Handlebars.registerHelper('ifGreaterEqualPrice', function (v1, v2, options) {
	if (v1 != undefined) {
		var firstPrice = parseInt(v1.replace(/\D/g, ''));
		var secondPrice = parseInt(v2.replace(/\D/g, ''));
		if (firstPrice >= secondPrice) {
			return options.fn(this);
		}
	} else {
		return options.fn(this);
	}
	return options.inverse(this);
});

Handlebars.registerHelper('ifLessPrice', function (v1, v2, options) {
	if (v1 != undefined) {
		var firstPrice = parseInt(v1.replace(/\D/g, ''));
		var secondPrice = parseInt(v2.replace(/\D/g, ''));
		if (firstPrice < secondPrice) {
			return options.fn(this);
		}
	}
	return options.inverse(this);
});

Handlebars.registerHelper('splitPrice', function(price) {
	var priseStr = price.toString(), strLength = priseStr.length;
	if(strLength > 3) {
		var firstPart = priseStr.slice(0, (strLength - 3));
		var secondPart = priseStr.slice(-3);
		return firstPart + ',' + secondPart;
	}else {
		return price;
	}
});

Handlebars.registerHelper('formatDate', function (message) {
	let date = message.replace(/\s+/g, "").match(/\d+[\/]\d+[\/]\d+/g)
	if (date && date.length) {
		let firstPart = message.slice(0, message.indexOf(date))
		let secondPart = message.slice(message.indexOf(date) + date[0].length)
		message = `${firstPart}  <span class="delivery-title-info-accent"> ${date[0]} </span>  ${secondPart}`
	}
	return message
});
